import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './InvitationVerification.css';

const InvitationVerification = () => {
  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [invitationData, setInvitationData] = useState(null);

  useEffect(() => {
    const verifyInvitation = async () => {
      try {
        const vtype = searchParams.get('vtype');
        const vtoken = searchParams.get('vtoken');

        if (!vtype || !vtoken || vtype !== 'orginvite') {
          throw new Error('Invalid invitation link');
        }

        const verifyResponse = await fetch(
          `${API_URL}/api/v1/auth/invitations/verify?token=${encodeURIComponent(vtoken)}`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'application/json'
            }
          }
        );

        if (!verifyResponse.ok) {
          throw new Error('Invalid or expired invitation');
        }

        const verifyData = await verifyResponse.json();
        
        if (!verifyData.status) {
          throw new Error('Invalid invitation response');
        }

        setInvitationData({
          email: verifyData.email,
          page: verifyData.page
        });

        // Redirect with token in URL
        setTimeout(() => {
          if (verifyData.page === 'login') {
            navigate(`/login?invitation=true&token=${encodeURIComponent(vtoken)}&email=${encodeURIComponent(verifyData.email)}`);
          } else {
            navigate(`/signup?invitation=true&token=${encodeURIComponent(vtoken)}&email=${encodeURIComponent(verifyData.email)}`);
          }
        }, 2000);

      } catch (error) {
        console.error('Invitation verification error:', error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };

    verifyInvitation();
    // eslint-disable-next-line
  }, [searchParams, navigate]);

  if (loading) {
    return (
      <div className="invitation-verification">
        <div className="verification-card">
          <div className="loading-spinner"></div>
          <p>Verifying invitation...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="invitation-verification">
        <div className="verification-card error">
          <i className="fas fa-exclamation-circle"></i>
          <h2>Verification Failed</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/')} className="home-button">
            Go to Home
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="invitation-verification">
      <div className="verification-card success">
        <i className="fas fa-check-circle"></i>
        <h2>Invitation Verified</h2>
        <p>
          Redirecting to {invitationData?.page === 'login' ? 'login' : 'registration'}...
        </p>
      </div>
    </div>
  );
};

export default InvitationVerification; 